import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Typography } from "@mui/material";

class VendorDetailsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <Grid container>
        <Stack p={0.5} mt={2}>
          <Breadcrumbs
            style={{ color: "#0DA861" }}
            separator="›"
            aria-label="breadcrumb"
          >
            <Typography sx={{ color: "#A2A7AE", fontSize: "14px" }}>
              Vendor
            </Typography>
            <Typography sx={{ color: "#0DA861", fontSize: "14px" }}>
              View details
            </Typography>
          </Breadcrumbs>
        </Stack>

        <Grid item xs={12}>
          <Paper sx={{ width: "95%", p: 3, mt: 1 }}></Paper>
        </Grid>
      </Grid>
    );
  }
}
export default VendorDetailsContainer;
